import axios from "axios";
import { SERVER_URL } from "../../utils/constants";
import HttpRequest from "../../utils/HttpRequest";

export const loginService = async (data) => {
  try {
    const res = await axios({
      method: "POST",
      url: `${SERVER_URL}/user/login`,
      data,
    });
    return res;
  } catch (err) {
    return err?.response;
  }
};

export const profileService = async (token) => {
  return HttpRequest.get(`${SERVER_URL}/user/profile`, token);
};

export const getOrganisationsService = async () => {
  return HttpRequest.get(`${SERVER_URL}/organisation`);
};